// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {CaptionCaps} from 'sail/Text';
import {DocsIcon} from 'docs/components';

type Props = {|
  tags: Array<string>,
|};

export const CodeSampleTags = ({tags}: Props) => {
  return (
    <Box flex flexGrow={1} style={{marginTop: 'auto'}}>
      <Group
        direction="horizontal"
        alignItems="center"
        padding={{top: 12}}
        spacing={8}
      >
        <DocsIcon category="general" icon="github" size={20} />
        <CaptionCaps>{tags.join(' · ')}</CaptionCaps>
      </Group>
    </Box>
  );
};
